module.exports = __webpack_public_path__ + "img/旋覆花.f9167255.jpg";